module.exports = __webpack_public_path__ + "media/images/japan/tips_6-fac5d9b27c8c8a77c8e4f05b25fbb7c8.jpg";